module.exports = __webpack_public_path__ + "static/media/tutorial-banner.8b6cb08f.png";